import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

import background from './assets/background.svg?inline';

import noise from '../../../../assets/noise.svg?inline';

export default makeStyles({ name: 'Layout' })((theme) => ({
    root: {
        position: 'relative',
        minWidth: 1280,
        width: '100vw',
        height: '100vh',
        overflow: 'auto',
        background: '#FFFFFF',
        color: '#232323',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            minWidth: 0
        },
        '&:before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            pointerEvents: 'none',
            filter: 'blur(100px)',
            opacity: 0.35
        },
        '&:after': {
            content: '""',
            position: 'fixed',
            inset: 0,
            backgroundImage: `url(${noise})`,
            backgroundRepeat: 'repeat',
            mixBlendMode: 'multiply',
            pointerEvents: 'none',
            opacity: 0.25
        }
    },

    header: {
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
        position: 'sticky'
    },
    content: {
        zIndex: 1,
        position: 'relative',
        maxWidth: 1280,
        margin: '0 auto',
        boxSizing: 'border-box',
        padding: '0 16px'
    }
}));
